export const AstraFiEmployeeUserCardStatus = {
  Active: "active",
  Deleted: "deleted",
} as const;
export type AstraFiEmployeeUserCardStatus =
  (typeof AstraFiEmployeeUserCardStatus)[keyof typeof AstraFiEmployeeUserCardStatus];
